// This icon file is generated automatically.
var PtoCheckSquareOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 32 32", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M13.53 20.55l-3.89-5.4c-.12-.16 0-.4.2-.4h1.47a1 1 0 01.8.42l2.23 3.09 4.91-6.81a1 1 0 01.81-.42h1.47c.2 0 .32.23.2.4l-6.58 9.12a1 1 0 01-1.62 0zM27.5 3.5a1 1 0 011 1v23a1 1 0 01-1 1h-23a1 1 0 01-1-1v-23a1 1 0 011-1h23zm-1.25 22.75V5.75H5.75v20.5h20.5z", "fill-rule": "nonzero" } }] }, "name": "pto-check-square", "theme": "outlined" };
export default PtoCheckSquareOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PtoCheckSquareOutlined.js
// module id = 3887
// module chunks = 0